import {
    Button,
    Grid,
    TextField
} from "@material-ui/core";
import CancelIcon from "@material-ui/icons/Cancel";
import SaveIcon from "@material-ui/icons/Save";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import {
    ValidatorForm,
    TextValidator,
} from "react-material-ui-form-validator";
import ValidatedDatePicker from "../../compartidos/ValidatedDatePicker";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import moment from "moment";
import "moment/locale/es";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useForm } from "../../../hooks/useForm";
import { SUBTIPO_EFECTORES } from "../../../utils/constants";

const FormPresupuestos = ({ handleSubmit, handleClose }) => {
    moment.locale("es");

    const { dataContrato, presupuesto } = useSelector((state) => state.contrataciones);

    const [
        formValues,
        handleInputChange,
        ,
        setearValor,
    ] = useForm({
        valor: presupuesto?.valor,
        fechaFinVigencia: presupuesto?.fechaVencimiento,
        observaciones: ""
    });

    const { fechaFinVigencia, valor, observaciones } = formValues;

    const onSubmit = (e) => {
        e.preventDefault()
        handleSubmit({ ...formValues })
    }
    // VALIDATORS
    useEffect(() => {
        const fechaInicioVigenciaContrato = dataContrato?.fechaInicioVigencia;
        const fechaFinVigenciaContrato = dataContrato?.fechaFinVigencia;

        // FECHA INICIO VIGENCIA
        ValidatorForm.addValidationRule(
            "isAfterFechaInicioVigenciaContrato",
            (value) => {
                if (
                    moment(value).isValid() &&
                    moment(value).isBefore(moment(fechaInicioVigenciaContrato))
                ) {
                    return false;
                }
                return true;
            }
        );

        // FECHA FIN VIGENCIA
        ValidatorForm.addValidationRule(
            "isBeforeFechaFinVigenciaContrato",
            (value) => {
                if (
                    moment(value).isValid() &&
                    moment(value).isAfter(moment(fechaFinVigenciaContrato))
                ) {
                    return false;
                }
                return true;
            }
        );

        ValidatorForm.addValidationRule(
            "isAfterFechaFinVigencia",
            (value) => {
                if (
                    moment(value).isValid() &&
                    moment(value).isSameOrAfter(moment(presupuesto?.fecha))
                ) {
                    return true;
                }
                return false;
            }
        );
    });

    return (
        <ValidatorForm onSubmit={onSubmit}>
            <Grid container spacing={1}>

                <Grid item xs={12}>
                    <TextValidator
                        label="Id Presupuesto Autorizaciones"
                        fullWidth
                        autoComplete="off"
                        disabled
                        defaultValue={presupuesto?.idPresupuesto}
                    />
                </Grid>
                <Grid item xs={12}>
                    <MuiPickersUtilsProvider
                        locale={esLocale}
                        utils={DateFnsUtils}
                    >
                        <TextValidator
                            fullWidth
                            label="Fecha Inicio Vigencia"
                            defaultValue={moment(presupuesto?.fecha).format("DD/MM/YYYY")}
                            disabled={true}
                        />
                    </MuiPickersUtilsProvider>
                </Grid>
                <Grid item xs={12}>
                    <MuiPickersUtilsProvider
                        locale={esLocale}
                        utils={DateFnsUtils}
                    >
                        <ValidatedDatePicker
                            fullWidth={true}
                            label="Fecha Fin Vigencia"
                            format="dd/MM/yyyy"
                            minDate={moment(presupuesto?.fecha)}
                            okLabel="Aceptar"
                            clearLabel="Limpiar"
                            cancelLabel="Cancelar"
                            name="fechaFinVigencia"
                            value={
                                fechaFinVigencia !== undefined &&
                                    moment(fechaFinVigencia).isValid()
                                    ? moment(fechaFinVigencia)
                                    : null
                            }
                            onChange={(e) => setearValor("fechaFinVigencia", e)}
                            KeyboardButtonProps={{
                                "aria-label": "change date",
                            }}
                            validators={
                                dataContrato.idSubTipoEfector === SUBTIPO_EFECTORES.EVENTUAL
                                    ?
                                    ['required', 'isAfterFechaFinVigencia']
                                    :
                                    [
                                        "required",
                                        "isAfterFechaInicioVigenciaContrato",
                                        "isBeforeFechaFinVigenciaContrato",
                                        'isAfterFechaFinVigencia'
                                    ]}
                            errorMessages={
                                dataContrato.idSubTipoEfector === SUBTIPO_EFECTORES.EVENTUAL
                                    ?
                                    ['La fecha de fin de vigencia es requerida', "La fecha de fin debe ser igual o mayor a la fecha de inicio"]
                                    :
                                    [
                                        "La fecha de fin de vigencia es requerida",
                                        "La fecha de fin de vigencia debe ser mayor a la fecha de inicio de vigencia del contrato",
                                        "La fecha de fin de vigencia debe ser menor a la fecha de fin de vigencia del contrato",
                                        "La fecha de fin debe ser igual o mayor a la fecha de inicio"
                                    ]
                            }
                        />
                    </MuiPickersUtilsProvider>
                </Grid>
                <Grid item xs={12}>
                    <TextValidator
                        label="Valor"
                        fullWidth
                        autoComplete="off"
                        name="valor"
                        value={valor}
                        onChange={handleInputChange}
                        validators={["required", "isFloat"]}
                        errorMessages={["El valor es requerido", "Solo numeros"]}
                        type="number"
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        label="Observaciones"
                        fullWidth
                        multiline
                        name="observaciones"
                        value={observaciones}
                        onChange={handleInputChange}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={2} justify="flex-end" style={{ marginTop: '1em' }}>
                <Grid item>
                    <Button
                        variant="contained"
                        color="secondary"
                        size="small"
                        startIcon={<CancelIcon />}
                        onClick={handleClose}
                    >
                        CERRAR
                    </Button>
                </Grid>
                <Grid item>
                    <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    startIcon={<SaveIcon />}
                    type='submit'
                    >
                        CARGAR
                    </Button>
                </Grid>
            </Grid>
        </ValidatorForm>
    )
}

export default FormPresupuestos